export default "__VITE_ASSET__DjT_jr24__"